import { render, staticRenderFns } from "./BotControls.vue?vue&type=template&id=039e2041&"
import script from "./BotControls.vue?vue&type=script&lang=ts&"
export * from "./BotControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports